module.exports = __webpack_public_path__ + "img/timg.43b7ae35.gif";